export default "__VITE_ASSET__157908d4__"